import i18next from 'i18next';
import { toast } from 'sonner';
import { getIntegrationErrorMessage } from '@/lib/integration-error-message.js';

export class ReportProfileIntegration {
    constructor(service) { this.service = service; }

    async index() { return this.#read(() => this.service.index()); }
    async list(reportKey) { return this.#read(() => this.service.list({ reportKey })); }
    async getById(id) { return this.#read(() => this.service.getById(id)); }

    async create(input) {
        return this.#mutate(
            () => this.service.create(input),
            'reportStudio:detailedReportProfile.profileCreated',
            'Report profile was created.',
        );
    }

    async update(id, input) {
        return this.#mutate(
            () => this.service.update(id, input),
            'reportStudio:detailedReportProfile.profileUpdated',
            'Report profile was updated.',
        );
    }

    async remove(id, expectedVersion) {
        return this.#mutate(
            () => this.service.remove(id, expectedVersion),
            'reportStudio:detailedReportProfile.profileDeleted',
            'Report profile was deleted.',
        );
    }

    async setDefault(id, expectedVersion) {
        return this.#mutate(
            () => this.service.setDefault(id, expectedVersion),
            'reportStudio:detailedReportProfile.profileDefaulted',
            'The default report profile was updated.',
        );
    }

    async #read(operation) {
        try {
            const response = await operation();
            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, error: this.#localizedError(error) };
        }
    }

    async #mutate(operation, key, fallback) {
        try {
            const response = await operation();
            toast.success(i18next.t(key, { defaultValue: fallback }));
            return { success: true, data: response.data };
        } catch (error) {
            const message = this.#localizedError(error);
            toast.error(message);
            return {
                success: false,
                error: message,
                code: error?.response?.data?.code || error?.data?.code || error?.code,
            };
        }
    }

    #localizedError(error) {
        return getIntegrationErrorMessage(error) || i18next.t('reportStudio:detailedReportProfile.requestFailed', {
            defaultValue: 'The report profile request could not be completed.',
        });
    }
}
